<template>
  <div class="masechtos-page page-container pt-3 pb-4">
    <div class="title d-flex align-items-center mb-2">
      <h3 class="mr-2">{{ $_t("KW:masechtos") }}</h3>
      <div class="ml-5">
        <b-input-group class>
          <b-form-input
            :placeholder="$_t('KW:search')"
            v-model="filterMasechtos"
          ></b-form-input>
          <b-input-group-text :slot="isRTL ? 'prepend' : 'append'">
            <i class="fa fa-search"></i>
          </b-input-group-text>
        </b-input-group>
      </div>
    </div>

    <transition-group tag="div" name="fade" class="row">
      <seder
        v-for="seder in filteredMasechtot"
        :key="seder.id"
        :seder="seder"
        class="mb-5"
      ></seder>
    </transition-group>
  </div>
</template>
<script>
import SederComponent from "./masechtos/Seder";
export default {
  metaInfo: function () {
    return {
      title: this.isComponent
        ? null
        : this.$_t("components:masechtos.selectMasechta"),
      meta: [{ name: 'description', content: this.metaDescription }],
    };
  },
  components: {
    Seder: SederComponent,
  },
  props: ["isComponent"],
  data: function () {
    return {
      loading: false,
      masechtos: null,
      filterMasechtos: "",
    };
  },
  created: function () {
    this.getData();
  },
  watch: {
    //$route: "getData"
  },
  methods: {
    getData: function () {
      var self = this;
      this.masechtos = null;
      this.loading = true;
      this.$http.get("/api/masechtot").then(function (response) {
        self.masechtos = response.data;
        self.loading = false;
      });
    },
  },
  computed: {
    metaDescription: function() {
      return !this.isComponent ? this.$_t('KW:site.metaWithName', { name: this.$_t("components:masechtos.selectMasechta") }) : this.$_t('KW:site.metaWithoutName');
    },
    filteredMasechtot: function () {
      if (this.filterMasechtos == "") {
        return this.masechtos;
      } else {
        var searchRegex = new RegExp(this.filterMasechtos, "i");
        var searchedArray = [];
        var masechtos = JSON.parse(JSON.stringify(this.masechtos));
        masechtos.forEach(function (value) {
          var tmpFilter = value.masechtot.filter(function (masechta) {
            return (
              searchRegex.test(masechta.name) ||
              searchRegex.test(masechta.name_hebrew)
            );
          });
          if (tmpFilter.length > 0) {
            var tmp = value;
            tmp.masechtot = tmpFilter;
            searchedArray.push(tmp);
          }
        });
        return searchedArray;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  div {
    // flex-grow: 1;
    input {
      border-radius: 20px 0 0 20px;
      border-right: none;
      padding-left: 20px;
    }
    .input-group-append .input-group-text {
      max-width: 50px;
      border-radius: 0 20px 20px 0;
      border-left: none;
      background: none;

      .fa {
        font-size: 1.1rem;
      }
    }
  }
}
</style>